export default __webpack_public_path__ + "static/media/closeIcon.0a65a028.svg";